<div class="mb-6">
    <app-header [id]="id"></app-header>
</div>

<div class="lg:pt-2 bg-gray-20 lg:border-b border-gray-300">
    <div class=" container mx-auto lg:px-16 lg:mb-20 px-3 space-y-4 ">

        <div class="flex flex-col lg:flex-row gap-4 mb-8">

            <div class="w-full  space-y-4">

                <h2 class="text-2xl font-bold font-mulish mb-6">Become a Sponsor </h2>

                @if (becomeSponsorTextSignal(); as sponsorText) {
                <p class="text-base font-mulish mb-3" [innerHTML]="sponsorText.becomeASponsorText | sanitizeHtmlText">
                </p>
                }
            </div>
        </div>

        <form [formGroup]="becomeSponsorForm" (ngSubmit)="onSubmit()" class="flex flex-col md:gap-4">
            <div class="flex flex-col md:flex-row md:gap-8">
                <div class="flex-1">
                    <label class="font-medium">Full Name</label>
                    <input formControlName="fullName" class="p-inputtext w-full border rounded-md px-3 py-2" />
                    <small class="text-red-500 block min-h-[1rem]"
                        [ngClass]="{ 'invisible': !getFieldError('fullName') }">
                        {{ getFieldError('fullName') || '' }}
                    </small>
                </div>
                <div class="flex-1">
                    <label class="font-medium">Email</label>
                    <input formControlName="email" class="p-inputtext w-full border rounded-md px-3 py-2" />
                    <small class="text-red-500 block min-h-[1rem]" [ngClass]="{ 'invisible': !getFieldError('email') }">
                        {{ getFieldError('email') || '' }}
                    </small>
                </div>
            </div>


            <div class="flex flex-col md:flex-row md:gap-8">
                <div class="flex-1">
                    <label class="font-medium">Organization Name</label>
                    <input formControlName="organization" class="p-inputtext w-full border rounded-md px-3 py-2" />
                </div>
                <div class="flex-1">
                    <label class="font-medium">Phone Number</label>
                    <input formControlName="mobile" class="p-inputtext w-full border rounded-md px-3 py-2" />
                </div>
            </div>

            <div class="flex flex-col sm:flex-row md:gap-6">

                <div class="flex flex-col sm:flex-1">
                    <label for="country" class="font-mulish text-base">Country</label>
                    <p-select id="country" formControlName="country" placeholder="" class="w-full text-sm"
                        optionLabel="name" optionValue="abbreviation" [options]="countries"></p-select>
                </div>

                <div class="flex flex-1">
                    <div class="flex-1">
                        <label for="zip" class="font-mulish text-base">{{labelPostalCode}}</label>
                        <input id="zip" formControlName="zip" class="p-inputtext w-full  border rounded-md px-3 py-2" />
                    </div>
                </div>
            </div>

            <div class="flex flex-col space-y-4">
                <div>
                    <label class="font-medium">Address 1</label>
                    <input formControlName="address1" class="p-inputtext w-full border rounded-md px-3 py-2" />
                </div>
                <div>
                    <label class="font-medium">Address 2</label>
                    <input formControlName="address2" class="p-inputtext w-full border rounded-md px-3 py-2" />
                </div>
            </div>



            <div class="flex flex-col sm:flex-row gap-1  md:gap-6">


                <div class="flex-1 ">
                    <label for="state" class="font-mulish text-base">{{labelState}}</label>

                    <ng-container *ngIf="states.length > 0; else stateTextInput">
                        <p-select id="state" formControlName="state" class="w-full text-sm  " [options]="states"
                            optionLabel="name" optionValue="abbreviation" placeholder="{{placeHolderState}}">
                        </p-select>
                    </ng-container>

                    <ng-template #stateTextInput>
                        <input id="state" formControlName="state"
                            class="p-inputtext w-full border  rounded-md px-3 py-2 " placeholder="Enter your region" />
                    </ng-template>
                </div>


                <div class="flex-1">
                    <label for="city" class="font-mulish text-base">City</label>
                    <input id="city" formControlName="city" class="p-inputtext w-full border  rounded-md px-3 py-2" />
                </div>

            </div>

            <label class="font-medium">Comment</label>
            <textarea id="comment" formControlName="comment" rows="6"
                class="p-inputtext w-full border rounded-md px-3 py-2 text-sm"></textarea>

            <div class="mt-4 flex gap-2">
                <button pButton type="button" label="Cancel"
                    class="h-[35px] !bg-white !border !border-[var(--p-primary-500)] !text-[var(--p-primary-500)] w-1/2 text-base font-medium"
                    [rounded]="true" [routerLink]="['/auction', id]">
                </button>

                <button class="p-button-info rounded-2xl w-full h-9 !text-[var(--p-text-color-secondary)] relative" type="submit">
                    Next
                </button>
            </div>

            <small class="text-red-500 block min-h-[1rem]" *ngIf="apiResponseError">
                {{ apiResponseError }}
            </small>

        </form>
    </div>
</div>

<div>
    <app-footer></app-footer>
</div>